import { IMember } from "@wingspanhq/users/dist/lib/interfaces";
import { FormDataAccountType } from ".";
import type {
  onboardingApiSpec,
  userApiSpec
} from "@wingspanhq/wingspan-api-types";

export function getProfileDataAccountType(
  monitoredEntity: onboardingApiSpec.CustomerEntity | undefined,
  member: IMember | undefined,
  userProfile: userApiSpec.UserProfileResponse | undefined
): Partial<FormDataAccountType> {
  const country = monitoredEntity?.country || member?.profile?.address?.country;
  const isUsPerson = !!userProfile?.taxProfiles?.["US"].firstName;

  return {
    country: monitoredEntity?.country || member?.profile?.address?.country,
    type: monitoredEntity?.type,
    isUsPerson: country !== "US" && isUsPerson
  };
}
